module.exports = __webpack_public_path__ + "static/img/torso16.6b6326b4.jpg";